import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-secondary-900">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">{siteInfo.name}</span>
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed">
              {siteInfo.tagline}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">视频分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">更多分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <a href={`mailto:${siteInfo.email}`} className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                  联系我们
                </a>
              </li>
              <li>
                <span className="text-sm text-secondary-400 whitespace-nowrap">{siteInfo.phone}</span>
              </li>
              <li>
                <span className="text-sm text-secondary-400 leading-relaxed block">{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-400 whitespace-nowrap">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}